import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'prg-schedule-tile',
  templateUrl: './schedule-tile.component.html',
  styleUrls: ['./schedule-tile.component.less']
})
export class ScheduleTileComponent implements OnInit {

  @Input() item: any;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/schedule-tile/schedule-tile.component.ts